<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Partner List
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Partner</a>
        </li>
      </ul>
    </div>
    <!-- detail search start -->
    <b-card v-show="so.adv && view_detail != false">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">Joined_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1MO</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1MO</b-button>
            <b-form inline class="mt-2 ml-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_visit">Login_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2" size="sm" variant="outline-primary" @click="set_sd('', 'last_visit')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'last_visit')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'last_visit')">-1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'last_visit')">-1MO</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'last_visit')">1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'last_visit')">1MO</b-button>
            <b-form inline class="mt-2 ml-2">
              <date-picker @change="refresh" v-model="so.opt.last_visit_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.last_visit_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_username_partner">Username</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_username_partner" v-model="so.opt['username']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_username_partner">Nickname</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_nickname_partner" v-model="so.opt['nickname']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mr-2">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false">
        <span class="badge badge_border_primary mb-2">TOTAL : <span style="padding-left: 1rem"></span>{{model.total.toString().padStart(4, nbsp) || 0 | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">USE : <span style="padding-left: 2.1rem"></span>{{model.enable.toString().padStart(4, nbsp) || 0 | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">Deleted : <span style="padding-left: 0.5rem"></span>{{model.disable.toString().padStart(4, nbsp) || 0 | number}}</span>
      </b-col>
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option value="">Search</option>
              <option value="username">Username</option>
              <option value="nickname">Nickname</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div>
          <div class="mb7 mr-2 mt-2">
            <b-button v-if="enable_new !== false" size="sm" class="btn btn-sm btn-addition mr-2" tabindex="4" @click="$router.push({ name: 'partner', params: { id : 'add' } })"> New Registration </b-button>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table  class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.partner.created_at | sdate }}</template>
            <template slot="status" slot-scope="row">
              <b-badge v-if="row.item.partner.is_del" variant="danger">Deleted</b-badge>
              <span v-else>
                <b-badge :variant="row.item.partner.is_alive ? 'success' : 'secondary'">{{row.item.partner.is_alive ? 'On' : 'Off'}}</b-badge>
              </span>
              <b-badge variant="outline-secondary">(Group : {{row.item.groupCount}})</b-badge>
            </template>
            <template slot="permissions" slot-scope="row">{{row.item.partner.permissions}}</template>
            <template slot="username" slot-scope="row">
              <del v-if="row.item.partner.is_del">{{row.item.partner.username}}</del>
              <span v-else>{{row.item.partner.username}}</span>
            </template>
            <template slot="nickname" slot-scope="row">
              {{row.item.partner.nickname}}
              <del v-if="row.item.partner.is_del">{{row.item.partner.nickname}}</del>
            </template>
            <template slot="last_visit" slot-scope="row">{{row.item.partner.last_visit | sdate }}</template>
            <!-- <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item.partner)" size="sm" class="btn btn-sm btn-insert">
              :disabled="view_detail == false && row.item.partner.parent_id && (row.item.partner.parent_id != model.id || row.item.partner.parent_id != model.parent_id)"
                {{view_detail !== false ? 'Detail' : 'Select'}}
              </b-btn>
            </template> -->
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>